import { NgModule } from '@angular/core'
import { InputComponent } from './input/input.component'
import { HeaderComponent } from './header/header.component'
import { DialogComponent } from './dialog/dialog.component'
import { SearchbarComponent } from './searchbar/searchbar.component'
import { CategoryComponent } from './category/category.component'
import { FiltersComponent } from './filters/filters.component'
import { PostItemComponent } from './post-item/post-item.component'
import { FilterInputComponent } from './filter-input/filter-input.component'
import { DetailsHeaderComponent } from './details-header/details-header.component'
import { PostInputComponent } from './post-input/post-input.component'
import { PublicInputComponent } from './public-input/public-input.component'
import { ChatFooterComponent } from './chat/chat-footer/chat-footer.component'
import { ChatHeaderComponent } from './chat/chat-header/chat-header.component'
import { ContainerComponent } from './chat/container/container.component'
import { MessagesComponent } from './chat/messages/messages.component'
import { NoHeaderComponent } from './no-header/no-header.component'
import { HomeMobileComponent } from './home-mobile/home-mobile.component'
import { HomeWebComponent } from './home-web/home-web.component'
import { HeaderWebComponent } from './header-web/header-web.component'
import { CategoryWebComponent } from './category-web/category-web.component'
import { WebNotificationsComponent } from './web-notifications/web-notifications.component'
import { FiltersSectionComponent } from './filters-section/filters-section.component'
import { DetailsMobileComponent } from './details-mobile/details-mobile.component'
import { DetailsWebComponent } from './details-web/details-web.component'
import { PhotoGalleryComponent } from './photo-gallery/photo-gallery.component'
import { SelectWebComponent } from './select-web/select-web.component'
import { MapComponent } from './map/map.component'
import { MapModalComponent } from './map-modal/map-modal.component'
import { CookieBannerComponent } from './cookie-banner/cookie-banner.component'
import { GratificationBannerComponent } from './chat/gratification-banner/gratification-banner.component'
import { PremiumChatLockComponent } from './chat/premium-chat-lock/premium-chat-lock.component'
import { ContactFinderDialogComponent } from './chat/contact-finder-dialog/contact-finder-dialog.component'
import { NotificationDetailDialogComponent } from './notification-detail-dialog/notification-detail-dialog.component'

const STANDALONE_COMPONENTS = [
  InputComponent,
  HeaderComponent,
  HeaderWebComponent,
  DetailsHeaderComponent,
  DetailsMobileComponent,
  DetailsWebComponent,
  DialogComponent,
  SearchbarComponent,
  CategoryComponent,
  CategoryWebComponent,
  FiltersComponent,
  FilterInputComponent,
  PostItemComponent,
  PostInputComponent,
  PublicInputComponent,
  ChatFooterComponent,
  ChatHeaderComponent,
  ContainerComponent,
  MessagesComponent,
  NoHeaderComponent,
  HomeMobileComponent,
  HomeWebComponent,
  WebNotificationsComponent,
  FiltersSectionComponent,
  PhotoGalleryComponent,
  SelectWebComponent,
  MapComponent,
  MapModalComponent,
  CookieBannerComponent,
  GratificationBannerComponent,
  PremiumChatLockComponent,
  ContactFinderDialogComponent,
  NotificationDetailDialogComponent,
]

@NgModule({
  imports: [...STANDALONE_COMPONENTS],
  exports: [...STANDALONE_COMPONENTS],
})
export class ComponentsModule {}
